<app-header></app-header>
<ion-content *ngIf="VM">
  <!-- Spinner template -->
  <ng-template #spinner>
    <ion-spinner name="circles" class="order-spinner"></ion-spinner>
  </ng-template>

  <!-- Bottom section loading spinner -->
  <ng-template #spinnerBottomSectionLoad>
    <ion-spinner name="circles" class="section-load-spinner"></ion-spinner>
  </ng-template>

  <!----------------------------- Start Desktop View -------------------------------->
  <div
    id="desktop"
    *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
  >
    <div class="top-section-background">
      <ion-grid [fixed]="true">
        <!-- Start Top Header -->
        <ion-row>
          <ion-col size="8">
            <app-breadcrumbs
              *ngIf="!VM?.navigationRestricted"
              [breadcrumbs]="breadcrumbs"
            ></app-breadcrumbs>
          </ion-col>
          <ion-col size="4" class="right-align-column">
            <ion-button
              class="btn-download"
              data-cy="download-order-button"
              (click)="showDownloadOrdersModal(true)"
              [disabled]="isSubmitting()"
              fill="clear"
            >
              <ion-icon name="download-outline"></ion-icon>
              {{ 'i18n.orderPage.download' | translate }}
            </ion-button>
            <ion-button
              class="btn-print"
              data-cy="print-order-button"
              (click)="printOrder()"
              [disabled]="isSubmitting()"
              fill="clear"
            >
              <ion-icon name="print-outline"></ion-icon>
              {{ 'i18n.orderPage.print' | translate }}
            </ion-button>
            <ion-button
              class="btn-share"
              data-cy="share-order-button"
              (click)="shareOrder()"
              [disabled]="isSubmitting()"
              fill="clear"
            >
              <ion-icon name="share-social-outline"></ion-icon>
              {{ 'i18n.orderPage.share' | translate }}
            </ion-button>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="9">
            <h1 translate data-cy="order-submitted-title">
              {{'i18n.confirmationPage.orderSubmitted' | translate}}
            </h1>

            <h3
              translate
              data-cy="thank-you-message-text"
              class="thank-you-title"
            >
              {{'i18n.confirmationPage.thankYouMsg'| translate}}
            </h3>
            <!-- Punchout exception resolution msg is for desktop only-->
            <div
              *ngIf="(isPunchoutSession$ | async) && VM?.splittedOrders?.length > 1 && hasSubmittedWithExceptions"
              class="punchOutMsg"
            >
              <ion-icon
                name="alert-circle-outline"
                class="alert-icon"
              ></ion-icon>
              <div>
                {{'i18n.confirmationPage.punchOutExceptionResolutionMsg' |
                translate}}
              </div>
            </div>
          </ion-col>
          <ion-col
            size="3"
            class="right-align-column"
            *ngIf="(!hasOnlyVSItems && VM?.masterOrderById?.orderHeader?.orderType === 'RT') &&
                  ( VM?.masterOrderById?.orderHeader?.minOrderDollarsDiff > 0 ||
                    VM?.masterOrderById?.orderHeader?.minOrderCasesDiff > 0 )"
          >
            <div
              class="order-minimum-container"
              data-cy="order-minimum-section-desktop"
            >
              <strong
                *ngIf="(isProntoDeliveryDate || isSuperUserProntoCustomer); else originalMinRemaining"
              >
                {{'i18n.confirmationPage.orderMinRemainingPronto' | translate}}:
              </strong>
              <ng-template #originalMinRemaining>
                <strong>
                  {{'i18n.confirmationPage.orderMinRemaining' | translate}}:
                </strong>
              </ng-template>
              <div>
                <span
                  *ngIf="VM?.masterOrderById?.orderHeader?.minOrderDollarsDiff > 0"
                >
                  {{VM?.masterOrderById?.orderHeader?.minOrderDollarsDiff || 0 |
                  currency }}
                </span>

                <span
                  *ngIf="VM?.masterOrderById?.orderHeader?.minOrderDollarsDiff > 0 &&
                            VM?.masterOrderById?.orderHeader?.minOrderCasesDiff > 0"
                  class="mini-border"
                >
                  |
                </span>

                <span
                  *ngIf="VM?.masterOrderById?.orderHeader?.minOrderCasesDiff > 0"
                >
                  {{ VM?.masterOrderById?.orderHeader?.minOrderCasesDiff || 0 }}
                  CS
                </span>
              </div>
              <p
                class="order-minimum-pronto-desc"
                *ngIf="(isProntoDeliveryDate || isSuperUserProntoCustomer)"
              >
                {{'i18n.confirmationPage.orderMinRemainingProntoDesc' |
                translate}}
              </p>
            </div>
            <ng-template #orderMinimumMetDesktop>
              <div
                class="order-minimum-section-met"
                data-cy="list-order-minimum-section"
              >
                <strong>
                  {{'i18n.confirmationPage.orderMinMet' | translate}}
                </strong>

                <div class="truck truck-animation">
                  <img src="assets/images/truck-no-wheels.svg" />
                  <div class="wheels">
                    <div class="wheels-animation wheel1"></div>
                    <div class="wheels-animation wheel2"></div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ion-col>
        </ion-row>

        <!-- End Top Header -->

        <!-- Start Top Section Order Information -->
        <ion-row>
          <ion-col size="4">
            <div class="order-info">
              <div data-cy="order-total-text">
                {{'i18n.confirmationPage.total' | translate}} &nbsp;
                <span *ngIf="VM?.orderTallies?.totalPrice > 0; else dash"
                  >{{VM?.orderTallies?.totalPrice | currency}}</span
                >
                <ng-template #dash>
                  <span> - </span>
                </ng-template>
              </div>
              <div data-cy="total-cases-eaches-text">
                {{'i18n.common.ordered' | translate}}: &nbsp;
                <span
                  *ngIf="VM?.orderTallies?.totalCases > 0 || VM?.orderTallies?.totalEaches > 0; else caseEachDash"
                  >{{ VM?.orderTallies?.totalCases }} CS / {{
                  VM?.orderTallies?.totalEaches }} EA</span
                >
                <ng-template #caseEachDash>
                  <span> - CS / - EA</span>
                </ng-template>
              </div>
              <div data-cy="total-cases-eaches-text">
                {{'i18n.common.reserved' | translate}}: &nbsp;
                <span
                  *ngIf=" !isSubmitting();
                  else caseEachDash"
                >
                  <span
                    [class.red-text]="VM?.orderTallies?.totalCasesReserved < VM?.orderTallies?.totalCases"
                    >{{ VM?.orderTallies?.totalCasesReserved || 0 }} CS </span
                  >/
                  <span
                    [class.red-text]="VM?.orderTallies?.totalEachesReserved < VM?.orderTallies?.totalEaches"
                    >{{ VM?.orderTallies?.totalEachesReserved }} EA</span
                  >
                </span>
              </div>
            </div>
          </ion-col>

          <ion-col size="4">
            <div class="order-info">
              <div data-cy="shipment-information-text">
                {{'i18n.confirmationPage.shipments' | translate}} &nbsp;
                <span *ngIf="VM?.orderTallies?.totalShipments > 0; else dash"
                  >{{VM?.orderTallies?.totalShipments}}</span
                >
              </div>
              <div data-cy="po-number-text">
                {{'i18n.confirmationPage.poNumber' | translate}} &nbsp;
                <span
                  >{{VM?.masterOrderById?.orderHeader?.purchaseOrderNumber}}</span
                >
              </div>
            </div>
          </ion-col>

          <ion-col size="4">
            <div class="shipping-address" data-cy="shipping-address-text">
              <div translate>{{'i18n.confirmationPage.shipTo'}}</div>
              <ng-container
                *ngIf="(VM?.shipToCustomer || ((superUserShipToCustomer$ | async) )) as shipToCustomer; else noShipToCustomer"
              >
                <ng-container
                  *ngIf="!!VM?.masterOrderById?.orderHeader?.shipToCustomer && hasSeparateShipToCustomer; else noShipToCustomer"
                >
                  <div>
                    {{ shipToCustomer?.customerName }} #{{
                    shipToCustomer?.customerNumber }} <br />
                    <ng-container *ngIf="!!VM?.shipToDepartmentName">
                      {{ ' (' + (VM?.shipToDepartmentName | titlecase) + ' #' +
                      (VM?.masterOrderById?.orderHeader?.shipToDepartment) + ')'
                      }}<br />
                    </ng-container>
                    {{shipToCustomer?.address1 + ' ' +
                    (!!VM?.shipToCustomer?.address2 ?shipToCustomer?.address2 :
                    '') }} <br />
                    {{shipToCustomer?.city }}, {{shipToCustomer?.state }} &nbsp;
                    {{shipToCustomer?.zip | zipcode}}
                  </div>
                </ng-container></ng-container
              >
              <ng-template #noShipToCustomer>
                <div>
                  {{ VM?.customerProfile?.address1 + ' ' +
                  (!!VM?.customerProfile?.address2 ?
                  VM?.customerProfile?.address2 : '') }} <br />
                  {{ VM?.customerProfile?.city }}, {{ VM?.customerProfile?.state
                  }} &nbsp; {{ VM?.customerProfile?.zip | zipcode}}
                </div>
              </ng-template>
            </div>
          </ion-col>
        </ion-row>

        <ion-button
          *ngIf="VM?.showTransferButton"
          data-cy="transfer-button"
          [ngClass]="{
            'usf-outline-green-button': !VM?.disableTransfer && expectedShipments <= VM?.splittedOrders.length,
            'usf-outline-disabled-button': VM?.disableTransfer || expectedShipments > VM?.splittedOrders.length,
            'transfer-button': true
          }"
          (click)="doPunchoutTransfer()"
        >
          {{ VM?.transferButtonText ? VM.transferButtonText :
          ('i18n.confirmationPage.transferBtn' | translate)}}
        </ion-button>
        <ion-button
          *ngIf="!VM.navigationRestricted"
          data-cy="view-all-orders-button"
          class="usf-outline-green-button"
          [routerLink]="(this.platformService?.isTouchExperience$ | async) ? ['/touch/my-orders-view'] : ['/desktop/my-orders-view']"
        >
          {{'i18n.confirmationPage.viewAllOrdersBtn' | translate}}
        </ion-button>
        <!-- End Top Section Order Information -->
      </ion-grid>
    </div>

    <!-- Bottom Section-Desktop Starts -->
    <div class="bottom-section-background">
      <ion-grid fixed="true">
        <ion-item
          class="banner-note"
          *ngIf="isDealsAvailable && !this.orderService?.orderSubmitted(VM?.masterOrderById?.orderHeader)"
        >
          <ion-label
            data-cy="confirmation-deals-note-text"
            data-cy="confirmation-deals-note-text"
          >
            <span class="note-bold">{{'i18n.common.note' | translate }}</span>
            <span class="note-regular">
              {{ 'i18n.confirmationPage.dealsNoteOnConfirmation' | translate }}
            </span>
          </ion-label>
        </ion-item>

        <!-------------------- Start Container - Orders -------------------->
        <!---------------------- Start Container - Order Submitting in Progress ---------------------->
        <ng-container
          *ngIf="!!VM?.masterOrderForView?.order else spinnerBottomSectionLoad"
        >
          <ng-container
            *ngIf="(
          VM?.masterOrderForView?.order?.orderHeader.orderStatus === orderStatusEnum.IN_PROGRESS ||
          VM?.masterOrderForView?.order?.orderHeader.orderStatus === orderStatusEnum.SUBMITTING ||
          VM?.masterOrderForView?.order?.orderHeader.orderStatus === orderStatusEnum.EDITING_SUBMITTED ||
          VM?.masterOrderForView?.order?.orderHeader.orderStatus === orderStatusEnum.DELETED ||
          VM?.masterOrderForView?.order?.orderHeader.editOrderInFlight === true
          ) && !VM?.splittedOrders?.length"
          >
            <ion-accordion-group>
              <ion-accordion>
                <ion-item id="no-ripple" class="gray-content-bg" slot="header">
                  <div class="order-submitted-section">
                    <div class="order-submitted-info">
                      <h5
                        [attr.data-cy]="'order-submitted-' + VM?.masterOrderForView?.order?.orderHeader?.tandemOrderNumber + '-title'"
                      >
                        <ng-container
                          *ngIf="VM?.masterOrderForView?.order?.orderHeader.orderType === 'RT'"
                        >
                          <ng-container
                            *ngIf="!isProntoDeliveryDate else prontoDelivery"
                          >
                            {{'i18n.confirmationPage.routedOrderDeliveryDesktop'
                            | translate}}</ng-container
                          >
                          <ng-template #prontoDelivery
                            >{{'i18n.confirmationPage.prontoOrderDeliveryDesktop'
                            | translate}}</ng-template
                          ></ng-container
                        >
                        <ng-container
                          *ngIf="VM?.masterOrderForView?.order?.orderHeader.orderType === 'VS'"
                        >
                          {{'i18n.confirmationPage.vendorOrderDeliveryDesktop' |
                          translate}}</ng-container
                        >
                        {{VM?.masterOrderForView?.order?.orderHeader?.confirmedDeliveryDate
                        | date:'M/d/yyyy':'GMT'}}
                      </h5>
                      <div
                        class="order-submitted-product-info"
                        [attr.data-cy]="'order-submitted-info-' + VM?.masterOrderForView?.order?.orderHeader?.tandemOrderNumber + '-text'"
                      >
                        <div>
                          {{'i18n.confirmationPage.products' | translate}}
                          {{VM?.masterOrderForView?.order?.orderItems?.length ||
                          0}} ({{VM?.orderTallies.totalCases}} CS /
                          {{VM?.orderTallies.totalEaches}} EA)
                          <ng-container
                            *ngIf="VM?.masterOrderForView?.order?.orderHeader.orderType === 'RT'"
                          >
                            <span>|</span>
                            {{'i18n.confirmationPage.orderWeight' | translate}}
                            {{VM?.masterOrderForView?.orderWeight | number
                            :'1.1-2'}} LB
                          </ng-container>
                          <span>|</span>
                          {{'i18n.confirmationPage.orderNumber' | translate}}
                          <ion-spinner
                            name="circles"
                            class="order-spinner"
                          ></ion-spinner>
                        </div>
                      </div>
                    </div>
                    <div
                      class="order-total"
                      [attr.data-cy]="'order-total-' + VM?.masterOrderForView?.order?.orderHeader?.tandemOrderNumber + '-text'"
                    >
                      {{'i18n.confirmationPage.total' | translate}}
                      <span>
                        <ng-container
                          *ngIf="VM?.masterOrderForView?.order?.orderHeader?.totalDollars else spinner"
                        >
                          {{VM?.masterOrderForView?.order?.orderHeader?.totalDollars
                          | currency}}</ng-container
                        >
                      </span>
                    </div>
                    <div class="submitting">
                      <div
                        class="submitting"
                        [attr.data-cy]="'order-submitting-' + VM?.masterOrderForView?.order?.orderHeader?.tandemOrderNumber + '-text'"
                      >
                        <div>
                          {{'i18n.confirmationPage.submitting' | translate}}
                        </div>

                        <ion-spinner
                          name="circles"
                          class="submitted-spinner"
                        ></ion-spinner>
                      </div>
                    </div>
                  </div>
                </ion-item>
                <ng-container
                  *ngIf="expandedShipments.has(VM?.masterOrderForView?.order?.orderHeader?.orderId)"
                >
                  <div class="gray-content-bg section-padding" slot="content">
                    <app-order-confirmation-item
                      *ngFor="let cartItem of VM?.masterOrderForView?.cartItems; let last = last"
                      [isLast]="last"
                      [cartItem]="cartItem"
                      [navigationRestricted]="VM?.navigationRestricted"
                      [availableToPromise]="VM?.masterOrderForView?.shouldShowAvailableToPromise"
                    ></app-order-confirmation-item>
                  </div>
                </ng-container>
              </ion-accordion>
              <div class="gray-border-bottom"></div>
            </ion-accordion-group>
          </ng-container>
        </ng-container>
        <!---------------------- /End Container - Order Submitting in Progress ---------------------->
        <!---------------------- Start - Child Submitted Orders ---------------------->
        <ng-container *ngIf="VM?.splittedOrders?.length">
          <ng-container *ngFor="let splittedOrder of VM?.splittedOrders">
            <ng-container
              *ngIf="splittedOrder?.order?.orderHeader.orderStatus !== orderStatusEnum.IN_PROGRESS && splittedOrder?.order?.orderHeader.orderStatus !== orderStatusEnum.SUBMITTING && splittedOrder?.order?.orderHeader.editOrderInFlight !== true"
            >
              <ion-accordion-group>
                <ion-accordion>
                  <ion-item
                    id="no-ripple"
                    class="gray-content-bg"
                    slot="header"
                  >
                    <div class="order-submitted-section">
                      <div class="order-submitted-info">
                        <h5
                          [attr.data-cy]="'order-delivery-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-title'"
                        >
                          <ng-container
                            *ngIf="splittedOrder?.order?.orderHeader.orderType === 'RT'"
                          >
                            <ng-container
                              *ngIf="!isProntoDeliveryDate else prontoDelivery"
                            >
                              {{'i18n.confirmationPage.routedOrderDeliveryDesktop'
                              | translate}}</ng-container
                            >
                            <ng-template #prontoDelivery
                              >{{'i18n.confirmationPage.prontoOrderDeliveryDesktop'
                              | translate}}</ng-template
                            ></ng-container
                          >

                          <ng-container
                            *ngIf="splittedOrder?.order?.orderHeader.orderType === 'VS'"
                          >
                            {{'i18n.confirmationPage.vendorOrderDeliveryDesktop'
                            | translate}}</ng-container
                          >
                          {{splittedOrder?.order?.orderHeader?.confirmedDeliveryDate
                          | date:'M/d/yyyy':'GMT'}}
                        </h5>
                        <div
                          class="order-submitted-product-info"
                          [attr.data-cy]="'submitted-product-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-text'"
                        >
                          <div>
                            {{'i18n.confirmationPage.products' | translate}}
                            {{splittedOrder?.order?.orderItems?.length || 0}}
                            ({{(splittedOrder?.order?.orderHeader.totalUnits ||
                            0)}} CS /
                            {{(splittedOrder?.order?.orderHeader.totalEaches ||
                            0)}} EA)
                            <ng-container
                              *ngIf="splittedOrder?.order?.orderHeader.orderType === 'RT'"
                            >
                              <span>|</span>
                              {{'i18n.confirmationPage.orderWeight' |
                              translate}} {{splittedOrder?.orderWeight | number
                              :'1.1-2'}} LB
                            </ng-container>
                            <span>|</span>
                            {{'i18n.confirmationPage.orderNumber' | translate}}
                            <ng-container
                              *ngIf="splittedOrder?.order?.orderHeader?.tandemOrderNumber else noTandemNumber"
                            >
                              {{splittedOrder?.order?.orderHeader.tandemOrderNumber}}
                            </ng-container>
                            <ng-template #noTandemNumber>
                              <ng-container
                                *ngIf="!splittedOrder?.order?.orderHeader?.tandemOrderNumber else spinner"
                              >
                                {{'i18n.confirmationPage.notApplicable' |
                                translate}}
                              </ng-container>
                            </ng-template>
                          </div>
                        </div>
                        <app-order-confirmation-special-instructions
                          [order]="splittedOrder?.order"
                        >
                        </app-order-confirmation-special-instructions>
                      </div>

                      <div
                        class="order-total"
                        [attr.data-cy]="'order-total-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-text'"
                      >
                        {{'i18n.confirmationPage.total' | translate}}
                        <span>
                          <ng-container
                            *ngIf="!splittedOrder?.order?.orderHeader?.tandemOrderNumber
                          || !splittedOrder?.order?.orderHeader?.totalPrice
                          || VM?.customerProfile?.ogPrintPriceInd === 'N';
                          else priceBlock"
                          >
                            {{'i18n.confirmationPage.notApplicable' |
                            translate}}
                          </ng-container>
                          <ng-template #priceBlock>
                            <ng-container
                              *ngIf="splittedOrder?.totalDisplayPrice else spinner"
                            >
                              {{splittedOrder?.totalDisplayPrice || 0 |
                              currency}}
                            </ng-container>
                          </ng-template>
                        </span>
                      </div>

                      <div
                        [attr.data-cy]="'order-error-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-text'"
                        *ngIf="splittedOrder?.order?.orderHeader?.orderStatus === orderStatusEnum.ORDER_ERROR"
                        class="order-error"
                      >
                        {{'i18n.confirmationPage.orderError' | translate}}
                        <br />

                        <ion-button
                          *ngIf="!VM?.navigationRestricted"
                          [attr.data-cy]="'resolve-order-error-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-button'"
                          class="usf-outline-orange-button resubmit-button"
                          (click)="resubmitOrder(splittedOrder?.order)"
                        >
                          {{'i18n.confirmationPage.viewResubmit' |
                          translate}}</ion-button
                        >
                      </div>
                      <div
                        [attr.data-cy]="'order-error-exceptions-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-text'"
                        *ngIf="splittedOrder?.order?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_WITH_EXCEPTIONS"
                        class="order-error"
                      >
                        {{'i18n.confirmationPage.submittedWithExceptions' |
                        translate}}
                        <br />

                        <ion-button
                          *ngIf="!VM?.navigationRestricted || VM?.exceptionRestricted"
                          [attr.data-cy]="'resolve-exceptions-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-button'"
                          class="usf-outline-orange-button"
                          (click)="navigateToOrderExceptions(splittedOrder?.order?.orderHeader, splittedOrder?.order?.orderItems)"
                        >
                          {{'i18n.orderExceptionsPage.resolveExceptions' |
                          translate}}</ion-button
                        >
                      </div>
                      <div
                        [attr.data-cy]="'order-submitted-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-text'"
                        *ngIf=" splittedOrder?.order?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED || splittedOrder?.order?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_CREDIT_HOLD"
                        class="submitted"
                      >
                        <div>
                          {{'i18n.confirmationPage.submitted' | translate}}
                        </div>
                        <div
                          *ngIf="(splittedOrder?.hasError &&
                        splittedOrder?.order?.orderHeader?.errorDetails?.errNumber
                        !== 50004) else nonModifiableOrderDesktop"
                        >
                          <ion-button
                            *ngIf="!VM?.navigationRestricted"
                            [attr.data-cy]="'view-details-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-button'"
                            class="usf-outline-green-button resubmit-button"
                            (click)="openOrder(splittedOrder?.order)"
                          >
                            {{ 'i18n.confirmationPage.viewResubmit' | translate
                            }}</ion-button
                          >
                        </div>
                      </div>
                      <ng-template #nonModifiableOrderDesktop
                        ><ion-button
                          *ngIf="!VM?.navigationRestricted"
                          [attr.data-cy]="'view-details-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-button'"
                          class="usf-outline-green-button resubmit-button"
                          (click)="openOrder(splittedOrder?.order)"
                        >
                          {{ 'i18n.confirmationPage.viewDetailsBtn' | translate
                          }}</ion-button
                        ></ng-template
                      >
                    </div>
                  </ion-item>
                  <div class="gray-content-bg section-padding" slot="content">
                    <app-order-confirmation-item
                      *ngFor="let cartItem of splittedOrder?.cartItems; let last = last"
                      [isLast]="last"
                      [cartItem]="cartItem"
                      [subbedItem]="cartItem.subbedItem"
                      [navigationRestricted]="VM?.navigationRestricted"
                      [availableToPromise]="splittedOrder?.shouldShowAvailableToPromise"
                    ></app-order-confirmation-item>
                  </div>
                </ion-accordion>
                <div class="gray-border-bottom"></div>
              </ion-accordion-group>
            </ng-container>
          </ng-container>
        </ng-container>
        <!---------------------- /End - Child Submitted Orders---------------------->
        <!-------------------- /End Container - Orders -------------------->

        <p data-cy="price-message-text">
          {{'i18n.confirmationPage.priceMsg' | translate}}
        </p>
      </ion-grid>
    </div>
  </div>
  <app-footer></app-footer>
  <!-- End Desktop View -->

  <!-- Start Touch Experience -->
  <div
    class="touch"
    *ngIf="(this.platformService?.isTouchExperience$ | async) === true"
  >
    <!-- Start Tablet View -->
    <div id="tablet">
      <div class="top-section-background">
        <ion-grid [fixed]="true">
          <!-- Start Tablet Top Header -->
          <ion-row>
            <ion-col>
              <h1
                translate
                data-cy="order-submitted-title"
                class="order-submtited-title"
              >
                {{'i18n.confirmationPage.orderSubmitted'}}
              </h1>
            </ion-col>
            <ion-col size="4" class="right-align-column">
              <ion-button
                class="btn-download"
                data-cy="download-order-button"
                (click)="showDownloadOrdersModal(true)"
                [disabled]="isSubmitting()"
                fill="clear"
              >
                <ion-icon name="download-outline"></ion-icon>
                {{ 'i18n.orderPage.download' | translate }}
              </ion-button>
              <ion-button
                class="btn-print"
                data-cy="print-order-button"
                [disabled]="isSubmitting()"
                (click)="printOrder()"
                fill="clear"
              >
                <ion-icon name="print-outline"></ion-icon>
                {{ 'i18n.orderPage.print' | translate }}
              </ion-button>
              <ion-button
                class="btn-share"
                data-cy="share-order-button"
                (click)="shareOrder()"
                [disabled]="isSubmitting()"
                fill="clear"
              >
                <ion-icon name="share-social-outline"></ion-icon>
                {{ 'i18n.orderPage.share' | translate }}
              </ion-button>
            </ion-col>
          </ion-row>
          <h1 translate data-cy="touch-thank-you-title" class="thank-you-title">
            {{'i18n.confirmationPage.thankYouMsg'}}
          </h1>

          <ion-col size="12">
            <ion-button
              *ngIf="VM?.showTransferButton"
              data-cy="transfer-button"
              [ngClass]="{
                'usf-outline-green-button': !VM?.disableTransfer && expectedShipments <= VM?.splittedOrders.length,
                'usf-outline-disabled-button': VM?.disableTransfer || expectedShipments > VM?.splittedOrders.length,
                'transfer-button': true
              }"
              (click)="doPunchoutTransfer()"
            >
              {{ VM?.transferButtonText ? VM.transferButtonText :
              ('i18n.confirmationPage.transferBtn' | translate)}}
            </ion-button>
            <ion-button
              *ngIf="!VM.navigationRestricted"
              data-cy="touch-view-all-orders-button"
              id="view-all-orders-btn"
              class="usf-outline-green-button"
              [routerLink]="(this.platformService?.isTouchExperience$ | async) ? ['/touch/my-orders-view'] : ['/desktop/my-orders-view']"
            >
              {{'i18n.confirmationPage.viewAllOrdersBtn' | translate}}
            </ion-button>
          </ion-col>

          <div
            class="order-minimum"
            data-cy="order-minimum-section-tablet"
            *ngIf="(!hasOnlyVSItems && VM?.masterOrderById?.orderHeader?.orderType === 'RT') &&
                  ( VM?.masterOrderById?.orderHeader?.minOrderDollarsDiff > 0 ||
                    VM?.masterOrderById?.orderHeader?.minOrderCasesDiff > 0 )"
          >
            <strong
              *ngIf="(isProntoDeliveryDate || isSuperUserProntoCustomer); else originalMinRemaining"
            >
              {{'i18n.confirmationPage.orderMinRemainingPronto' | translate}}:
            </strong>
            <ng-template #originalMinRemaining>
              <strong>
                {{'i18n.confirmationPage.orderMinRemaining' | translate}}:
              </strong>
            </ng-template>
            <div class="remaining">
              <span
                *ngIf="VM?.masterOrderById?.orderHeader?.minOrderDollarsDiff > 0"
              >
                {{VM?.masterOrderById?.orderHeader?.minOrderDollarsDiff || 0 |
                currency }}
              </span>

              <span
                *ngIf="VM?.masterOrderById?.orderHeader?.minOrderDollarsDiff > 0 &&
                          VM?.masterOrderById?.orderHeader?.minOrderCasesDiff > 0"
                class="mini-border"
              >
                |
              </span>

              <span
                *ngIf="VM?.masterOrderById?.orderHeader?.minOrderCasesDiff > 0"
              >
                {{ VM?.masterOrderById?.orderHeader?.minOrderCasesDiff || 0 }}
                CS
              </span>
            </div>
            <ng-template #orderMinimumMetTablet>
              <div class="met">
                {{'i18n.confirmationPage.orderMinMet' | translate}}
              </div>
            </ng-template>
          </div>

          <p
            class="order-minimum-pronto-desc"
            *ngIf="(!hasOnlyVSItems && VM?.masterOrderById?.orderHeader?.orderType === 'RT') &&
                    ( VM?.masterOrderById?.orderHeader?.minOrderDollarsDiff > 0 ||
                      VM?.masterOrderById?.orderHeader?.minOrderCasesDiff > 0 ) &&
                    (isProntoDeliveryDate || isSuperUserProntoCustomer)"
          >
            {{'i18n.confirmationPage.orderMinRemainingProntoDesc' | translate}}
          </p>

          <!-- End Tablet Top Header -->

          <!-- Start Tablet Top Section Order Information -->
          <ion-row>
            <ion-col size="4">
              <div
                class="order-info"
                data-cy="touch-order-order-infomation-text"
              >
                <div>
                  <div data-cy="order-total-text">
                    {{'i18n.confirmationPage.total' | translate}} &nbsp;
                    <span *ngIf="VM?.orderTallies?.totalPrice > 0; else dash"
                      >{{VM?.orderTallies?.totalPrice | currency}}</span
                    >
                    <ng-template #dash>
                      <span> - </span>
                    </ng-template>
                  </div>
                  <div data-cy="total-cases-eaches-text">
                    {{'i18n.common.ordered' | translate}}: &nbsp;
                    <span
                      *ngIf="VM?.orderTallies?.totalCases > 0 || VM?.orderTallies?.totalEaches > 0; else caseEachDash"
                      >{{ VM?.orderTallies?.totalCases }} CS / {{
                      VM?.orderTallies?.totalEaches }} EA</span
                    >
                    <ng-template #caseEachDash>
                      <span> - CS / - EA</span>
                    </ng-template>
                  </div>
                  <div data-cy="total-cases-eaches-text">
                    {{'i18n.common.reserved' | translate}}: &nbsp;
                    <span
                      *ngIf=" !isSubmitting();
                      else caseEachDash"
                    >
                      <span
                        [class.red-text]="VM?.orderTallies?.totalCasesReserved < VM?.orderTallies?.totalCases"
                        >{{ VM?.orderTallies?.totalCasesReserved || 0 }} CS </span
                      >/
                      <span
                        [class.red-text]="VM?.orderTallies?.totalEachesReserved < VM?.orderTallies?.totalEaches"
                        >{{ VM?.orderTallies?.totalEachesReserved }} EA</span
                      >
                    </span>
                  </div>
                </div>
              </div>
            </ion-col>
            <ion-col size="4">
              <div class="order-info" data-cy="touch-order-infomation-text">
                <div>
                  {{'i18n.confirmationPage.shipments' | translate}} &nbsp;
                  <span>{{VM?.orderTallies?.totalShipments}}</span>
                </div>
                <div>
                  {{'i18n.confirmationPage.poNumber' | translate}} &nbsp;
                  <span
                    >{{VM?.masterOrderById?.orderHeader?.purchaseOrderNumber}}</span
                  >
                </div>
              </div>
            </ion-col>
            <ion-col size="4">
              <!-- TOUCH -->
              <div
                class="shipping-address"
                data-cy="touch-shipping-information-text"
              >
                <div>
                  {{'i18n.confirmationPage.shipTo' | translate}} <br />
                  <ng-container
                    *ngIf="(VM?.shipToCustomer || ((superUserShipToCustomer$ | async) )) as shipToCustomer; else noShipToCustomer"
                  >
                    <ng-container
                      *ngIf="!!VM?.masterOrderById?.orderHeader?.shipToCustomer && hasSeparateShipToCustomer; else noShipToCustomer"
                    >
                      {{ shipToCustomer?.customerName }} #{{
                      shipToCustomer?.customerNumber }} <br />
                      <ng-container *ngIf="!!VM?.shipToDepartmentName">
                        {{ ' (' + (VM?.shipToDepartmentName | titlecase) + ' #'
                        + (VM?.masterOrderById?.orderHeader?.shipToDepartment) +
                        ')' }}<br />
                      </ng-container>
                      {{ shipToCustomer?.address1 + ' ' +
                      (!!shipToCustomer?.address2 ? shipToCustomer?.address2 :
                      '') }} <br />
                      {{ shipToCustomer?.city }}, {{ shipToCustomer?.state }}
                      &nbsp; {{ shipToCustomer?.zip | zipcode}}
                    </ng-container></ng-container
                  >
                  <ng-template #noShipToCustomer>
                    {{ VM?.customerProfile?.address1 + ' ' +
                    (!!VM?.customerProfile?.address2 ?
                    VM?.customerProfile?.address2 : '')}} <br />
                    {{ VM?.customerProfile?.city }}, {{
                    VM?.customerProfile?.state }} &nbsp; {{
                    VM?.customerProfile?.zip | zipcode}}
                  </ng-template>
                </div>
              </div>
            </ion-col>
          </ion-row>
          <!-- End Tablet Top Section Order Information -->
        </ion-grid>
      </div>

      <div class="bottom-section-background">
        <ion-grid fixed="true">
          <ion-item
            class="banner-note"
            *ngIf="isDealsAvailable && !this.orderService?.orderSubmitted(VM?.masterOrderById?.orderHeader)"
          >
            <ion-label data-cy="confirmation-deals-note-text" text-wrap>
              <span class="note-bold">{{'i18n.common.note' | translate }}</span>
              <span class="note-regular">
                {{ 'i18n.confirmationPage.dealsNoteOnConfirmation' | translate
                }}
              </span>
            </ion-label>
          </ion-item>

          <!------ Tablet  - All orders---- -->

          <!-- Start Tablet Container - Orders -->
          <!------ Start Tablet Container - Order Submitting in Progress -------->
          <ng-container
            *ngIf="!!VM?.masterOrderForView?.order else spinnerBottomSectionLoad"
          >
            <ng-container
              *ngIf="(
          VM?.masterOrderForView?.order?.orderHeader.orderStatus === orderStatusEnum.IN_PROGRESS ||
          VM?.masterOrderForView?.order?.orderHeader.orderStatus === orderStatusEnum.SUBMITTING ||
          VM?.masterOrderForView?.order?.orderHeader.orderStatus === orderStatusEnum.EDITING_SUBMITTED ||
          VM?.masterOrderForView?.order?.orderHeader.orderStatus === orderStatusEnum.DELETED ||
          VM?.masterOrderForView?.order?.orderHeader?.editOrderInFlight === true
          ) && !VM?.splittedOrders?.length"
            >
              <ion-accordion-group>
                <ion-accordion>
                  <ion-item
                    id="no-ripple"
                    class="gray-content-bg"
                    slot="header"
                  >
                    <div class="order-submitted-section">
                      <div class="order-submitted-info">
                        <h5
                          [attr.data-cy]="'touch-order-submitted-info-' + VM?.masterOrderForView?.order?.orderHeader?.tandemOrderNumber + '-title'"
                        >
                          <ng-container
                            *ngIf="VM?.masterOrderForView?.order?.orderHeader.orderType === 'RT'"
                          >
                            <ng-container
                              *ngIf="!isProntoDeliveryDate else prontoDelivery"
                            >
                              {{'i18n.confirmationPage.routedOrderDeliveryTouch'
                              | translate}}</ng-container
                            >
                            <ng-template #prontoDelivery
                              >{{'i18n.confirmationPage.prontoOrderDeliveryTouch'
                              | translate}}</ng-template
                            ></ng-container
                          >
                          <ng-container
                            *ngIf="VM?.masterOrderForView?.order?.orderHeader.orderType === 'VS'"
                          >
                            {{'i18n.confirmationPage.vendorOrderDeliveryTouch' |
                            translate}}</ng-container
                          >
                          {{VM?.masterOrderForView?.order?.orderHeader?.requestedDeliveryDate
                          | date:'M/d/yyyy':'GMT'}}
                        </h5>
                        <div
                          class="order-submitted-product-info"
                          [attr.data-cy]="'touch-order-product-info-' + VM?.masterOrderForView?.order?.orderHeader?.tandemOrderNumber + '-text'"
                        >
                          <div>
                            {{'i18n.confirmationPage.products' | translate}}
                            {{VM?.masterOrderForView?.order?.orderItems?.length
                            || 0}} ({{VM?.orderTallies?.totalCases}} CS /
                            {{VM?.orderTallies?.totalEaches}} EA)
                            <ng-container
                              *ngIf="VM?.masterOrderForView?.order?.orderHeader.orderType === 'RT'"
                            >
                              <span>|</span>
                              {{'i18n.confirmationPage.orderWeight' |
                              translate}} {{VM?.masterOrderForView?.orderWeight
                              | number :'1.1-2'}} LB
                            </ng-container>
                            <span>|</span>
                            {{'i18n.confirmationPage.orderNumber' | translate}}
                            <ion-spinner
                              name="circles"
                              class="order-spinner"
                            ></ion-spinner>
                          </div>
                        </div>
                      </div>
                      <div
                        class="order-total"
                        [attr.data-cy]="'touch-order-total-' + VM?.masterOrderForView?.order?.orderHeader?.tandemOrderNumber + '-text'"
                      >
                        {{'i18n.confirmationPage.total' | translate}}
                        <ng-container
                          *ngIf="VM?.masterOrderForView?.order?.orderHeader?.totalDollars else spinner"
                        >
                          {{VM?.masterOrderForView?.order?.orderHeader?.totalDollars
                          | currency}}</ng-container
                        >
                      </div>

                      <div
                        class="submitting"
                        [attr.data-cy]="'touch-order-submitting-' + VM?.masterOrderForView?.order?.orderHeader?.tandemOrderNumber + '-text'"
                      >
                        {{'i18n.confirmationPage.submitting' | translate}}
                        <ion-spinner
                          name="circles"
                          class="submitted-spinner"
                        ></ion-spinner>
                      </div>
                    </div>
                  </ion-item>
                  <div class="gray-content-bg section-padding" slot="content">
                    <app-order-confirmation-item
                      *ngFor="let cartItem of VM?.masterOrderForView?.cartItems; let last = last"
                      [isLast]="last"
                      [cartItem]="cartItem"
                      [subbedItem]="cartItem.subbedItem"
                      [navigationRestricted]="VM?.navigationRestricted"
                    ></app-order-confirmation-item>
                  </div>
                </ion-accordion>
                <div class="gray-border-bottom"></div>
              </ion-accordion-group>
            </ng-container>
          </ng-container>
          <!--------- /End Tablet Container - Order Submitting in Progress ---------->

          <!--------- Start Tablet Container - Child Submitted Orders ----------->
          <ng-container *ngIf="VM?.splittedOrders?.length">
            <ng-container *ngFor="let splittedOrder of VM?.splittedOrders">
              <ng-container
                *ngIf="splittedOrder?.order?.orderHeader.orderStatus !== orderStatusEnum.IN_PROGRESS && splittedOrder?.order?.orderHeader.orderStatus !== orderStatusEnum.SUBMITTING && splittedOrder?.order?.orderHeader.editOrderInFlight !== true"
              >
                <ion-accordion-group>
                  <ion-accordion>
                    <ion-item
                      id="no-ripple"
                      class="gray-content-bg"
                      slot="header"
                    >
                      <div class="order-submitted-section">
                        <div class="order-submitted-info">
                          <h5
                            [attr.data-cy]="'touch-order-submitted-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-title'"
                          >
                            <ng-container
                              *ngIf="splittedOrder?.order?.orderHeader.orderType === 'RT'"
                            >
                              <ng-container
                                *ngIf="!isProntoDeliveryDate else prontoDelivery"
                              >
                                {{'i18n.confirmationPage.routedOrderDeliveryTouch'
                                | translate}}</ng-container
                              >
                              <ng-template #prontoDelivery
                                >{{'i18n.confirmationPage.prontoOrderDeliveryTouch'
                                | translate}}</ng-template
                              ></ng-container
                            >
                            <ng-container
                              *ngIf="splittedOrder?.order?.orderHeader.orderType === 'VS'"
                            >
                              {{'i18n.confirmationPage.vendorOrderDeliveryTouch'
                              | translate}}</ng-container
                            >
                            {{splittedOrder?.order?.orderHeader?.confirmedDeliveryDate
                            | date:'M/d/yyyy':'GMT'}}
                          </h5>
                          <div
                            class="order-submitted-product-info"
                            [attr.data-cy]="'touch-order-submitted-info-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-text'"
                          >
                            <div>
                              {{'i18n.confirmationPage.products' | translate}}
                              {{splittedOrder?.order?.orderItems?.length || 0}}
                              ({{(splittedOrder?.order?.orderHeader.totalUnits
                              || 0)}} CS /
                              {{(splittedOrder?.order?.orderHeader.totalEaches
                              || 0)}} EA)
                              <ng-container
                                *ngIf="splittedOrder?.order?.orderHeader.orderType === 'RT'"
                              >
                                <span>|</span>
                                {{'i18n.confirmationPage.orderWeight' |
                                translate}} {{splittedOrder?.orderWeight |
                                number :'1.1-2'}} LB
                              </ng-container>
                              <span>|</span>
                              {{'i18n.confirmationPage.orderNumber' |
                              translate}}
                              <ng-container
                                *ngIf="splittedOrder?.order?.orderHeader?.tandemOrderNumber else noTandemNumber"
                              >
                                {{splittedOrder?.order?.orderHeader.tandemOrderNumber}}
                              </ng-container>
                              <app-order-confirmation-special-instructions
                                [order]="splittedOrder?.order"
                              >
                              </app-order-confirmation-special-instructions>
                              <ng-template #noTandemNumber>
                                <ng-container
                                  *ngIf="!splittedOrder?.order?.orderHeader?.tandemOrderNumber else spinner"
                                >
                                  {{'i18n.confirmationPage.notApplicable' |
                                  translate}}
                                </ng-container>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                        <div
                          class="order-total"
                          [attr.data-cy]="'touch-order-total-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-text'"
                        >
                          {{'i18n.confirmationPage.total' | translate}}
                          <span>
                            <ng-container
                              *ngIf="!splittedOrder?.order?.orderHeader?.tandemOrderNumber
                          || !splittedOrder?.order?.orderHeader?.totalPrice
                          || VM?.customerProfile?.ogPrintPriceInd === 'N';
                          else priceBlock"
                            >
                              {{'i18n.confirmationPage.notApplicable' |
                              translate}}
                            </ng-container>
                            <ng-template #priceBlock>
                              <ng-container
                                *ngIf="splittedOrder?.totalDisplayPrice else spinner"
                              >
                                {{splittedOrder?.totalDisplayPrice || 0 |
                                currency}}
                              </ng-container>
                            </ng-template>
                          </span>
                        </div>
                        <div
                          [attr.data-cy]="'touch-order-error-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-text'"
                          *ngIf="splittedOrder?.order?.orderHeader?.orderStatus === orderStatusEnum.ORDER_ERROR"
                          class="order-error"
                        >
                          {{'i18n.confirmationPage.orderError' | translate}}
                          <br />

                          <ion-button
                            *ngIf="!VM?.navigationRestricted"
                            [attr.data-cy]="'resolve-order-error-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-button'"
                            class="usf-outline-orange-button resubmit-button"
                            (click)="resubmitOrder(splittedOrder?.order)"
                          >
                            {{'i18n.confirmationPage.viewResubmit' |
                            translate}}</ion-button
                          >
                        </div>
                        <div
                          [attr.data-cy]="'touch-order-error-exceptions-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-text'"
                          *ngIf="splittedOrder?.order?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_WITH_EXCEPTIONS"
                          class="order-error"
                        >
                          {{'i18n.confirmationPage.submittedWithExceptions' |
                          translate}}
                          <br />

                          <ion-button
                            *ngIf="!VM?.navigationRestricted || VM?.exceptionRestricted"
                            [attr.data-cy]="'touch-resolve-exceptions-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-button'"
                            id="resolve-exceptions-btn"
                            class="usf-outline-orange-button"
                            (click)="navigateToOrderExceptions(splittedOrder?.order?.orderHeader, splittedOrder?.order?.orderItems)"
                          >
                            {{'i18n.orderExceptionsPage.resolveExceptions' |
                            translate}}</ion-button
                          >
                        </div>
                        <div
                          [attr.data-cy]="'touch-order-submitted-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-text'"
                          *ngIf="splittedOrder?.order?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED || splittedOrder?.order?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_CREDIT_HOLD"
                          class="submitted"
                        >
                          <div>
                            {{'i18n.confirmationPage.submitted' | translate}}
                          </div>
                          <div
                            *ngIf="(splittedOrder?.hasError &&
                          splittedOrder?.order?.orderHeader?.errorDetails?.errNumber
                          !== 50004) else nonModifiableOrderTablet"
                          >
                            <ion-button
                              *ngIf="!VM?.navigationRestricted"
                              [attr.data-cy]="'touch-view-order-details-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-button'"
                              id="view-details-btn"
                              class="usf-outline-green-button"
                              (click)="openOrder(splittedOrder?.order)"
                            >
                              {{ 'i18n.confirmationPage.viewResubmit' |
                              translate }}</ion-button
                            >
                          </div>
                          <ng-template #nonModifiableOrderTablet>
                            <ion-button
                              *ngIf="!VM?.navigationRestricted"
                              [attr.data-cy]="'touch-view-order-details-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-button'"
                              id="view-details-btn"
                              class="usf-outline-green-button"
                              (click)="openOrder(splittedOrder?.order)"
                            >
                              {{ 'i18n.confirmationPage.viewDetailsBtn' |
                              translate }}</ion-button
                            ></ng-template
                          >
                        </div>
                      </div>
                    </ion-item>
                    <div class="gray-content-bg section-padding" slot="content">
                      <app-order-confirmation-item
                        *ngFor="let cartItem of splittedOrder?.cartItems; let last = last"
                        [isLast]="last"
                        [cartItem]="cartItem"
                        [subbedItem]="cartItem.subbedItem"
                        [navigationRestricted]="VM?.navigationRestricted"
                        [availableToPromise]="splittedOrder?.shouldShowAvailableToPromise"
                      ></app-order-confirmation-item>
                    </div>
                  </ion-accordion>
                  <div class="gray-border-bottom"></div>
                </ion-accordion-group>
              </ng-container>
              <!--------- /End Tablet Container - Child Submitted Orders ----------->
            </ng-container>
          </ng-container>
          <!-- End Tablet Container - Orders -->

          <p data-cy="touch-price-message-text">
            {{'i18n.confirmationPage.priceMsg' | translate}}
          </p>
        </ion-grid>
      </div>
    </div>
    <!-- End Tablet View -->

    <!-- Start Mobile View -->
    <div id="mobile">
      <div class="top-section-background">
        <ion-grid [fixed]="true">
          <!-- Start Mobile Top Section -->
          <ion-row>
            <ion-col size="11">
              <h1 translate data-cy="order-submitted-title">
                {{'i18n.confirmationPage.orderSubmitted'}}
              </h1>
            </ion-col>
            <ion-col size="1" class="additional-info-ellipsis-col">
              <ion-icon
                class="additional-info-ellipsis"
                [class.disabled]="isSubmitting()"
                data-cy="additional-info-ellipsis-icon"
                name="ellipsis-vertical"
                (click)="showOrderConfirmationActionSheet(true)"
              ></ion-icon>
            </ion-col>
          </ion-row>
          <h1 data-cy="mobile-order-thank-you-title" class="thank-you-title">
            {{'i18n.confirmationPage.thankYouMsgMobileLine1' | translate}}
            {{'i18n.confirmationPage.thankYouMsgMobileLine2' | translate}}
          </h1>

          <div
            class="order-minimum"
            data-cy="order-minimum-section-mobile"
            *ngIf="(!hasOnlyVSItems && VM?.masterOrderById?.orderHeader?.orderType === 'RT') &&
                  ( VM?.masterOrderById?.orderHeader?.minOrderDollarsDiff > 0 ||
                    VM?.masterOrderById?.orderHeader?.minOrderCasesDiff > 0 )"
          >
            <strong
              *ngIf="(isProntoDeliveryDate || isSuperUserProntoCustomer); else originalMinRemaining"
            >
              {{'i18n.confirmationPage.orderMinRemainingPronto' | translate}}:
            </strong>
            <ng-template #originalMinRemaining>
              <strong>
                {{'i18n.confirmationPage.orderMinRemaining' | translate}}:
              </strong>
            </ng-template>
            <div class="remaining">
              <span
                *ngIf="VM?.masterOrderById?.orderHeader?.minOrderDollarsDiff > 0"
              >
                {{VM?.masterOrderById?.orderHeader?.minOrderDollarsDiff || 0 |
                currency }}
              </span>

              <span
                *ngIf="VM?.masterOrderById?.orderHeader?.minOrderDollarsDiff > 0 &&
                          VM?.masterOrderById?.orderHeader?.minOrderCasesDiff > 0"
                class="mini-border"
              >
                |
              </span>

              <span
                *ngIf="VM?.masterOrderById?.orderHeader?.minOrderCasesDiff > 0"
              >
                {{ VM?.masterOrderById?.orderHeader?.minOrderCasesDiff || 0 }}
                CS
              </span>
            </div>
            <ng-template #orderMinimumMetMobile>
              <div class="met">
                {{'i18n.confirmationPage.orderMinMet' | translate}}
              </div>
            </ng-template>
          </div>

          <p
            class="order-minimum-pronto-desc"
            *ngIf="(!hasOnlyVSItems && VM?.masterOrderById?.orderHeader?.orderType === 'RT') &&
                    ( VM?.masterOrderById?.orderHeader?.minOrderDollarsDiff > 0 ||
                      VM?.masterOrderById?.orderHeader?.minOrderCasesDiff > 0 ) &&
                    (isProntoDeliveryDate || isSuperUserProntoCustomer)"
          >
            {{'i18n.confirmationPage.orderMinRemainingProntoDesc' | translate}}
          </p>

          <ion-row>
            <ion-col size="12">
              <div
                class="order-info"
                data-cy="mobile-order-order-infomation-text"
              >
                <div>
                  <div data-cy="order-total-text">
                    {{'i18n.confirmationPage.total' | translate}} &nbsp;
                    <span *ngIf="VM?.orderTallies?.totalPrice > 0; else dash"
                      >{{VM?.orderTallies?.totalPrice | currency}}</span
                    >
                    <ng-template #dash>
                      <span> - </span>
                    </ng-template>
                  </div>
                  <div data-cy="total-cases-eaches-text">
                    {{'i18n.common.ordered' | translate}}: &nbsp;
                    <span
                      *ngIf="VM?.orderTallies?.totalCases > 0 || VM?.orderTallies?.totalEaches > 0; else caseEachDash"
                      >{{ VM?.orderTallies?.totalCases }} CS / {{
                      VM?.orderTallies?.totalEaches }} EA</span
                    >
                    <ng-template #caseEachDash>
                      <span> - CS / - EA</span>
                    </ng-template>
                  </div>
                  <div data-cy="total-cases-eaches-text">
                    {{'i18n.common.reserved' | translate}}: &nbsp;
                    <span
                      *ngIf=" !isSubmitting();
                      else caseEachDash"
                    >
                      <span
                        [class.red-text]="VM?.orderTallies?.totalCasesReserved < VM?.orderTallies?.totalCases"
                        >{{ VM?.orderTallies?.totalCasesReserved || 0 }} CS </span
                      >/
                      <span
                        [class.red-text]="VM?.orderTallies?.totalEachesReserved < VM?.orderTallies?.totalEaches"
                        >{{ VM?.orderTallies?.totalEachesReserved }} EA</span
                      >
                    </span>
                  </div>
                </div>
              </div>
            </ion-col>
            <ion-col size="12">
              <div class="order-info" data-cy="mobile-order-po-shipping-text">
                <div>
                  {{'i18n.confirmationPage.poNumber' | translate}} &nbsp;
                  <span
                    >{{VM?.masterOrderById?.orderHeader?.purchaseOrderNumber}}</span
                  >
                </div>
                <div>
                  {{'i18n.confirmationPage.shipments' | translate}} &nbsp;
                  <span>{{VM?.orderTallies?.totalShipments}}</span>
                </div>
              </div>
            </ion-col>
            <ion-col size="12">
              <div
                class="shipping-address"
                data-cy="mobile-order-shipping-infomation-text"
              >
                <div>
                  {{'i18n.confirmationPage.shipTo' | translate}} <br />
                  <ng-container
                    *ngIf="(VM?.shipToCustomer || ((superUserShipToCustomer$ | async) )) as shipToCustomer; else noShipToCustomer"
                  >
                    <ng-container
                      *ngIf="!!VM?.masterOrderById?.orderHeader?.shipToCustomer && hasSeparateShipToCustomer; else noShipToCustomer"
                    >
                      {{ shipToCustomer?.customerName }} #{{
                      shipToCustomer?.customerNumber }} <br />
                      <ng-container *ngIf="!!VM?.shipToDepartmentName">
                        {{ ' (' + (VM?.shipToDepartmentName | titlecase) + ' #'
                        + (VM?.masterOrderById?.orderHeader?.shipToDepartment) +
                        ')' }}<br />
                      </ng-container>
                      {{ shipToCustomer?.address1 + ' ' +
                      (!!shipToCustomer?.address2 ? shipToCustomer?.address2 :
                      '') }} <br />
                      {{ shipToCustomer?.city }}, {{ shipToCustomer?.state }}
                      &nbsp; {{ shipToCustomer?.zip | zipcode}}
                    </ng-container></ng-container
                  >
                  <ng-template #noShipToCustomer>
                    {{ VM?.customerProfile?.address1 + ' ' +
                    (!!VM?.customerProfile?.address2 ?
                    VM?.customerProfile?.address2 : '')}} <br />
                    {{ VM?.customerProfile?.city }}, {{
                    VM?.customerProfile?.state }} &nbsp; {{
                    VM?.customerProfile?.zip | zipcode}}
                  </ng-template>
                </div>
              </div>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12">
              <ion-button
                *ngIf="VM?.showTransferButton"
                data-cy="transfer-button"
                [ngClass]="{
                  'usf-outline-green-button': !VM?.disableTransfer && expectedShipments <= VM?.splittedOrders.length,
                  'usf-outline-disabled-button': VM?.disableTransfer || expectedShipments > VM?.splittedOrders.length,
                  'transfer-button': true
                }"
                (click)="doPunchoutTransfer()"
              >
                {{ VM?.transferButtonText ? VM.transferButtonText :
                ('i18n.confirmationPage.transferBtn' | translate)}}
              </ion-button>
              <ion-button
                *ngIf="!VM.navigationRestricted"
                data-cy="mobile-view-all-orders-button"
                id="view-all-orders-btn"
                class="usf-outline-green-button"
                [routerLink]="(this.platformService?.isTouchExperience$ | async) ? ['/touch/my-orders-view'] : ['/desktop/my-orders-view']"
              >
                {{'i18n.confirmationPage.viewAllOrdersBtn' | translate}}
              </ion-button>
            </ion-col>

            <ion-col size="12">
              <ion-item
                class="banner-note add-margin"
                *ngIf="isDealsAvailable && !this.orderService?.orderSubmitted(VM?.masterOrderById?.orderHeader)"
              >
                <ion-label data-cy="confirmation-deals-note-text" text-wrap>
                  <span class="note-bold"
                    >{{'i18n.common.note' | translate }}</span
                  >
                  <span class="note-regular">
                    {{ 'i18n.confirmationPage.dealsNoteOnConfirmation' |
                    translate }}
                  </span>
                </ion-label>
              </ion-item>
            </ion-col>
          </ion-row>
          <!-- End Mobile Top Order Information -->
        </ion-grid>
      </div>
      <div class="bottom-section-background">
        <ion-grid fixed="true">
          <!-- Start Mobile Container - Orders -->
          <!-- Start Mobile Container - Order Submitting in Progress -->
          <ng-container
            *ngIf="!!VM?.masterOrderForView?.order else spinnerBottomSectionLoad"
          >
            <ng-container
              *ngIf="(
                  VM?.masterOrderForView?.order?.orderHeader.orderStatus === orderStatusEnum.IN_PROGRESS ||
                  VM?.masterOrderForView?.order?.orderHeader.orderStatus === orderStatusEnum.SUBMITTING ||
                  VM?.masterOrderForView?.order?.orderHeader.orderStatus === orderStatusEnum.EDITING_SUBMITTED ||
                  VM?.masterOrderForView?.order?.orderHeader.orderStatus === orderStatusEnum.DELETED ||
                  VM?.masterOrderForView?.order?.orderHeader.editOrderInFlight === true
                  ) && !VM?.splittedOrders?.length"
            >
              <ion-accordion-group>
                <ion-accordion>
                  <ion-item
                    id="no-ripple"
                    class="gray-content-bg"
                    slot="header"
                  >
                    <div class="order-submitted-section">
                      <div class="order-submitted-info">
                        <h5
                          [attr.data-cy]="'mobile-order-submitted-info-' + VM?.masterOrderForView?.order?.orderHeader?.tandemOrderNumber + '-title'"
                        >
                          <ng-container
                            *ngIf="VM?.masterOrderForView?.order?.orderHeader.orderType === 'RT'"
                          >
                            <ng-container
                              *ngIf="!isProntoDeliveryDate else prontoDelivery"
                            >
                              {{'i18n.confirmationPage.routedOrderDeliveryTouch'
                              | translate}}</ng-container
                            >
                            <ng-template #prontoDelivery
                              >{{'i18n.confirmationPage.prontoOrderDeliveryTouch'
                              | translate}}</ng-template
                            ></ng-container
                          >
                          <ng-container
                            *ngIf="VM?.masterOrderForView?.order?.orderHeader.orderType === 'VS'"
                          >
                            {{'i18n.confirmationPage.vendorOrderDeliveryTouch' |
                            translate}}</ng-container
                          >
                          {{VM?.masterOrderForView?.order?.orderHeader?.confirmedDeliveryDate
                          | date:'M/d/yyyy':'GMT'}}
                        </h5>
                        <div
                          class="order-total"
                          [attr.data-cy]="'mobile-order-total-' + VM?.masterOrderForView?.order?.orderHeader?.tandemOrderNumber + '-text'"
                        >
                          {{'i18n.confirmationPage.total' | translate}}
                          <span>
                            <ng-container
                              *ngIf="VM?.masterOrderForView?.order?.orderHeader?.totalDollars else spinner"
                            >
                              {{VM?.masterOrderForView?.order?.orderHeader?.totalDollars
                              | currency}}</ng-container
                            >
                          </span>
                        </div>
                        <div class="order-submitted-product-info">
                          <div
                            [attr.data-cy]="'mobile-order-submitted-product-info-' + VM?.masterOrderForView?.order?.orderHeader?.tandemOrderNumber + '-text'"
                          >
                            {{'i18n.confirmationPage.products' | translate}}
                            {{VM?.masterOrderForView?.order?.orderItems?.length
                            || 0}} ({{VM?.orderTallies?.totalCases}} CS /
                            {{VM?.orderTallies?.totalEaches}} EA)
                          </div>
                          <div
                            class="mobile-weight"
                            [attr.data-cy]="'mobile-order-submitted-product-weight-' + VM?.masterOrderForView?.order?.orderHeader?.tandemOrderNumber + '-text'"
                          >
                            <ng-container
                              *ngIf="VM?.masterOrderForView?.order?.orderHeader.orderType === 'RT'"
                            >
                              {{'i18n.confirmationPage.orderWeight' |
                              translate}} {{VM?.masterOrderForView?.orderWeight
                              | number :'1.1-2'}} LB
                              <span>|</span>
                            </ng-container>
                            {{'i18n.confirmationPage.orderNumber' | translate}}
                            <ion-spinner
                              name="circles"
                              class="order-spinner"
                            ></ion-spinner>
                          </div>
                          <div
                            class="submitting"
                            [attr.data-cy]="'mobile-order-submitting-' + VM?.masterOrderForView?.order?.orderHeader?.tandemOrderNumber + '-text'"
                          >
                            {{'i18n.confirmationPage.submitting' | translate}}
                            <ion-spinner
                              name="circles"
                              class="submitted-spinner"
                            >
                            </ion-spinner>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ion-item>
                  <div class="gray-content-bg section-padding" slot="content">
                    <app-order-confirmation-item
                      *ngFor="let cartItem of VM?.masterOrderForView?.cartItems; let last = last"
                      [isLast]="last"
                      [cartItem]="cartItem"
                      [subbedItem]="cartItem.subbedItem"
                      [navigationRestricted]="VM?.navigationRestricted"
                      [availableToPromise]="VM?.masterOrderForView?.shouldShowAvailableToPromise"
                    ></app-order-confirmation-item>
                  </div>
                </ion-accordion>
                <div class="gray-border-bottom"></div>
              </ion-accordion-group>
            </ng-container>
          </ng-container>
          <!------------- End Mobile Container - Order Submitting in Progress ------------>

          <!------------- Start Mobile - Child Submitted Orders ------------>
          <ng-container *ngIf="VM?.splittedOrders?.length">
            <ng-container *ngFor="let splittedOrder of VM?.splittedOrders">
              <ng-container
                *ngIf="splittedOrder?.order?.orderHeader.orderStatus !== orderStatusEnum.IN_PROGRESS && splittedOrder?.order?.orderHeader.orderStatus !== orderStatusEnum.SUBMITTING && splittedOrder?.order?.orderHeader.editOrderInFlight !== true"
              >
                <ion-accordion-group>
                  <ion-accordion>
                    <ion-item
                      id="no-ripple"
                      class="gray-content-bg"
                      slot="header"
                    >
                      <div class="order-submitted-section">
                        <div class="order-submitted-row">
                          <div class="order-submitted-info">
                            <h5
                              [attr.data-cy]="'mobile-order-submitted-info-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-title'"
                            >
                              <ng-container
                                *ngIf="splittedOrder?.order?.orderHeader.orderType === 'RT'"
                              >
                                <ng-container
                                  *ngIf="!isProntoDeliveryDate else prontoDelivery"
                                >
                                  {{'i18n.confirmationPage.routedOrderDeliveryTouch'
                                  | translate}}</ng-container
                                >
                                <ng-template #prontoDelivery
                                  >{{'i18n.confirmationPage.prontoOrderDeliveryTouch'
                                  | translate}}</ng-template
                                ></ng-container
                              >
                              <ng-container
                                *ngIf="splittedOrder?.order?.orderHeader.orderType === 'VS'"
                              >
                                {{'i18n.confirmationPage.vendorOrderDeliveryTouch'
                                | translate}}</ng-container
                              >
                              {{splittedOrder?.order?.orderHeader?.confirmedDeliveryDate
                              | date:'M/d/yyyy':'GMT'}}
                            </h5>
                            <div
                              class="order-total"
                              [attr.data-cy]="'mobile-order-total-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-text'"
                            >
                              {{'i18n.confirmationPage.total' | translate}}
                              <span>
                                <ng-container
                                  *ngIf="!splittedOrder?.order?.orderHeader?.tandemOrderNumber
                                || !splittedOrder?.order?.orderHeader?.totalPrice
                                || VM?.customerProfile?.ogPrintPriceInd === 'N';
                                else priceBlock"
                                >
                                  {{'i18n.confirmationPage.notApplicable' |
                                  translate}}
                                </ng-container>
                                <ng-template #priceBlock>
                                  <ng-container
                                    *ngIf="splittedOrder?.totalDisplayPrice else spinner"
                                  >
                                    {{splittedOrder?.totalDisplayPrice || 0 |
                                    currency}}
                                  </ng-container>
                                </ng-template>
                              </span>
                            </div>
                            <div
                              class="order-submitted-product-info"
                              [attr.data-cy]="'mobile-order-submitted-product-info-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-text'"
                            >
                              <div>
                                {{'i18n.confirmationPage.products' | translate}}
                                {{splittedOrder?.order?.orderItems?.length ||
                                0}}
                                ({{(splittedOrder?.order?.orderHeader.totalUnits
                                || 0)}} CS /
                                {{(splittedOrder?.order?.orderHeader.totalEaches
                                || 0)}} EA)
                              </div>
                              <div
                                class="mobile-weight"
                                [attr.data-cy]="'mobile-order-submitted-product-weight-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-text'"
                              >
                                <ng-container
                                  *ngIf="splittedOrder?.order?.orderHeader.orderType === 'RT'"
                                >
                                  {{'i18n.confirmationPage.orderWeight' |
                                  translate}} {{splittedOrder?.orderWeight |
                                  number :'1.1-2'}} LB
                                  <span>|</span>
                                </ng-container>
                                {{'i18n.confirmationPage.orderNumber' |
                                translate}}
                                <ng-container
                                  *ngIf="splittedOrder?.order?.orderHeader?.tandemOrderNumber else noTandemNumber"
                                >
                                  {{splittedOrder?.order?.orderHeader.tandemOrderNumber}}
                                </ng-container>
                                <ng-template #noTandemNumber>
                                  <ng-container
                                    *ngIf="!splittedOrder?.order?.orderHeader?.tandemOrderNumber
                                  || VM?.customerProfile?.ogPrintPriceInd === 'N';
                                  else spinner"
                                  >
                                    {{'i18n.confirmationPage.notApplicable' |
                                    translate}}
                                  </ng-container>
                                </ng-template>
                              </div>
                              <app-order-confirmation-special-instructions
                                [order]="splittedOrder?.order"
                              >
                              </app-order-confirmation-special-instructions>
                              <div
                                [attr.data-cy]="'mobile-order-error-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-text'"
                                *ngIf="splittedOrder?.order?.orderHeader?.orderStatus === orderStatusEnum.ORDER_ERROR"
                                class="order-error"
                              >
                                {{'i18n.confirmationPage.orderError' |
                                translate}}

                                <ion-button
                                  *ngIf="!VM?.navigationRestricted"
                                  [attr.data-cy]="'resolve-order-error-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-button'"
                                  class="usf-outline-orange-button resubmit-button"
                                  (click)="resubmitOrder(splittedOrder?.order)"
                                >
                                  {{'i18n.confirmationPage.viewResubmit' |
                                  translate}}</ion-button
                                >
                              </div>
                              <div
                                *ngIf="splittedOrder?.order?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_WITH_EXCEPTIONS"
                                class="order-error"
                              >
                                {{'i18n.confirmationPage.submittedWithExceptions'
                                | translate}}

                                <ion-button
                                  *ngIf="!VM?.navigationRestricted || VM?.exceptionRestricted"
                                  id="resolve-exceptions-btn"
                                  class="usf-outline-orange-button"
                                  [attr.data-cy]="'mobile-order-exception-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-button'"
                                  (click)="navigateToOrderExceptions(splittedOrder?.order?.orderHeader, splittedOrder?.order?.orderItems)"
                                >
                                  {{'i18n.orderExceptionsPage.resolveExceptions'
                                  | translate}}</ion-button
                                >
                              </div>
                              <div
                                *ngIf="splittedOrder?.order?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED || splittedOrder?.order?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_CREDIT_HOLD "
                                class="submitted"
                              >
                                {{'i18n.confirmationPage.submitted' |
                                translate}}
                                <div
                                  *ngIf="(splittedOrder?.hasError &&
                                splittedOrder?.order?.orderHeader?.errorDetails?.errNumber
                                !== 50004) else nonModifiableOrderMobile"
                                >
                                  <ion-button
                                    *ngIf="!VM?.navigationRestricted"
                                    id="view-details-btn"
                                    class="usf-outline-green-button"
                                    [attr.data-cy]="'mobile-view-details-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-button'"
                                    (click)="openOrder(splittedOrder?.order)"
                                  >
                                    {{ 'i18n.confirmationPage.viewResubmit' |
                                    translate }}
                                  </ion-button>
                                </div>
                                <ng-template #nonModifiableOrderMobile>
                                  <ion-button
                                    *ngIf="!VM?.navigationRestricted"
                                    id="view-details-btn"
                                    class="usf-outline-green-button"
                                    [attr.data-cy]="'mobile-view-details-' + splittedOrder?.order?.orderHeader?.tandemOrderNumber + '-button'"
                                    (click)="openOrder(splittedOrder?.order)"
                                  >
                                    {{ 'i18n.confirmationPage.viewDetailsBtn' |
                                    translate }}
                                  </ion-button></ng-template
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ion-item>
                    <div class="gray-content-bg section-padding" slot="content">
                      <app-order-confirmation-item
                        *ngFor="let cartItem of splittedOrder?.cartItems; let last = last"
                        [isLast]="last"
                        [cartItem]="cartItem"
                        [subbedItem]="cartItem.subbedItem"
                        [navigationRestricted]="VM?.navigationRestricted"
                        [availableToPromise]="splittedOrder?.shouldShowAvailableToPromise"
                      ></app-order-confirmation-item>
                    </div>
                  </ion-accordion>
                  <div class="gray-border-bottom"></div>
                </ion-accordion-group>
              </ng-container>
            </ng-container>
          </ng-container>
          <!------------- End Mobile - Child Submitted Orders ------------>
          <!-- End Mobile Container - Orders -->

          <p data-cy="mobile-order-price-message-text">
            {{'i18n.confirmationPage.priceMsg' | translate}}
          </p>
        </ion-grid>
      </div>
    </div>
    <!-- End Mobile View-->
  </div>
  <!-- End Touch Experience-->
  <ion-action-sheet
    class="action-sheet-touch"
    mode="ios"
    [isOpen]="showOrderConfirmationActionSheet$ | async"
    (didDismiss)="showOrderConfirmationActionSheet(false)"
    [buttons]="constructDownloadOrderButtons()"
  ></ion-action-sheet>
</ion-content>

<ion-modal
  [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'modal-desktop-size-lg'"
  [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 0.5, 1] : undefined"
  [isOpen]="showDownloadOrderModal$ | async"
  (ionModalDidDismiss)="showDownloadOrdersModal(false)"
>
  <ng-template>
    <app-download-order-modal
      class="ion-page"
      [orders]="getOrdersFromSplittedOrders(VM.splittedOrders)"
      [platform]="platformService.platformType"
      (dismissEvent)="showDownloadOrdersModal(false)"
      (downloadOrdersEmitter)="handleDownloadOrders($event)"
    >
    </app-download-order-modal>
  </ng-template>
</ion-modal>
